export const initialState = () => ({
  uuid: null,
  isEditing: false,
  currentStep: 0,
  steps: ["Informações", "Funções", "Acessos"],
  step_name_routes: [0, "report-infos", "report-roles", "report-accesses"],
  indexStepsAlreadyVisited: 1,
  previousRoute: "",
  report: {
    title: "",
    text: "",
    publicationDate: null,
    expirationDate: null,
    readRequired: false,
    read: false,
    active: false,
    providerId: null,
    uploads: [],
    formatedUploads: [],
    role: {
      roles: [],
      isAllRoles: false
    },
    chain: {
      chains: [],
      isAllChains: false
    },
    pdvs: [],
    newFiles: [],
    deletedFilesIds: []
  },
  filter: {
    publicationDate: null,
    title: ""
  },
  loading: {
    show: false,
    message: ""
  }
})
